var React = require('react');

function Topper (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.5609 9.0679C20.465 10.6338 19.9284 12.636 18.3626 13.54L14.4367 15.8067C12.8708 16.7107 10.8686 16.1742 9.96456 14.6084C9.06049 13.0425 9.597 11.0402 11.1629 10.1362L15.0887 7.86955C16.6546 6.96554 18.6568 7.50205 19.5609 9.0679Z","fill":"#49CC68","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.2712 1.63747C16.1753 3.20333 15.6388 5.20559 14.0729 6.10963L4.91132 11.3991C3.34546 12.3032 1.34321 11.7667 0.43916 10.2008C-0.46489 8.63495 0.0716152 6.63268 1.63747 5.72861L10.7991 0.43916C12.365 -0.46489 14.3672 0.0716136 15.2712 1.63747Z","fill":"#49CC68","key":1})]);
}

Topper.defaultProps = {"width":"20","height":"17","viewBox":"0 0 20 17","fill":"none"};

module.exports = Topper;

Topper.default = Topper;
